import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, SimpleChange, OnChanges, SimpleChanges, AfterContentChecked, ChangeDetectorRef, Directive } from "@angular/core";
import { EnvironmentService } from "../../../services/environment.service";
import { HelperService } from "../../../services/helper/helper.service";
import { AuthenticationService } from "../../services/authentication.service";
import { Observable } from "rxjs";
import { Router } from '@angular/router';
import { AldFormBaseComponent } from '../form/ald-form.component'

import { Select, Store } from '@ngxs/store';

import { AldState } from "../../../services/ald/ald.state";
import * as AldActions from "../../../services/ald/ald.action";

import * as GarageVisitsAction from '../../../services/garage-visits/garage-visits.action';
import { GarageVisitsState } from '../../../services/garage-visits/garage-visits.state';

import * as GarageVisitsModels from '../../../models/garage-visits/garage-visits';
import * as Models from "../../../models/commonModels";
import * as CarModels from "../../../models/car/car";
import * as GarageModels from '../../../models/garage/garage';

import { BannerService } from '../../../shared/services/banner.service';

@Directive()
export abstract class AldVisitFormBaseComponent extends AldFormBaseComponent implements OnInit {

  public IsEmailValid: boolean = false;

  public IsTelephoneValid: boolean = false;

  public currentStep: number = 0;

  public car: CarModels.CarModel;

  public requestGarageVisitSave: Models.ContextRequest<CarModels.CarModel, GarageVisitsModels.GarageVisitModel> = new Models.ContextRequest<CarModels.CarModel,GarageVisitsModels.GarageVisitModel>();

  public currentGarage: GarageModels.GaragePreviewModel;

  public garageVisits: GarageVisitsModels.GarageVisitModel[];

  public garageVisitsSearch: GarageVisitsModels.GarageVisitsSearchModel = new GarageVisitsModels.GarageVisitsSearchModel();

  public garageVisitPlaceList: GarageVisitsModels.GarageVisitsPlaceListModel;

  public garageVisitsPlaceSearch: GarageVisitsModels.GarageVisitsPlaceSearch = new GarageVisitsModels.GarageVisitsPlaceSearch();

  public garageRequest: Models.RequestModel;

  public slectedDate: Date = new Date();

  public currentDate: Date = new Date();

  public currentDateId: number;

  public selectedMonth: Date = new Date();

  public timeSlots: GarageVisitsModels.GarageVisitsTimeSlotModel[] = null;

  public now: Date = new Date();

  public isDialogDisplayAddNewVisit: boolean = false;

  public isDialogDisplayEditVisit: boolean = false;

  public visitTimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel;

  public visitGarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel;

  public blockedDayList: GarageVisitsModels.GarageBlockedModel[];

  public searchDays: GarageVisitsModels.GarageBlockedHourSearch = new GarageVisitsModels.GarageBlockedHourSearch();

  public newGarageVisit: GarageVisitsModels.GarageVisitModel = new GarageVisitsModels.GarageVisitModel();


  @Select(GarageVisitsState.GarageVisits)
  GagareVisits$: Observable<Models.ResponseList<GarageVisitsModels.GarageVisitModel>>;

  @Select(GarageVisitsState.GarageVisitsPlaceList)
  GarageVisitsPlaceList$: Observable<GarageVisitsModels.GarageVisitsPlaceListModel>;

  @Select(AldState.GarageVisit)
  GarageVisit$: Observable<Models.Response<GarageVisitsModels.GarageVisitModel>>;

  @Select(GarageVisitsState.GarageBlockedDayList)
  GarageBlockedDayList$: Observable<GarageVisitsModels.GarageBlockedListModel>;

  @Select(AldState.Car)
  Car$: Observable<Models.Response<CarModels.CarModel>>;


  constructor(
    public helperService: HelperService,
    public environmentService: EnvironmentService,
    public changeDetectionRef: ChangeDetectorRef,
    public router: Router,
    public authenticationService: AuthenticationService,
    public store: Store,
    public bannerService: BannerService
  ) {
    super(helperService, environmentService, changeDetectionRef, router, authenticationService, store);
  }

  ngOnInit() {

    super.ngOnInit();

    this.subscription.add(this.GarageVisit$.subscribe((data) => {

      if (data) {
        if (data.Success) {

          if (data.RequestSignature == this.requestGarageVisitSave.RequestSignature) {

            this.bannerService.instantSuccess("Dziękujemy za rezerwacje wizyty. Na 24h przed umówionym terminem zostanie przesłany SMS z przypomnieniem.");

            this.onHome();
          }
        }
      }
    }));

    this.subscription.add(this.Car$.subscribe((data) => {
      if (data && data.Success && data.Item.CarId == this.currentUser.CarId) {
        this.car = data.Item;
      }
    }));

    this.subscription.add(this.GagareVisits$.subscribe((data) => {
      if (data && data.Success) {
        this.garageVisits = data.Items;
      }
    }));

    this.subscription.add(this.GarageVisitsPlaceList$.subscribe((ret) => {
      if (ret && ret.RequestSignature === this.garageVisitsPlaceSearch.RequestSignature) {
        this.garageVisitPlaceList = ret;

        this.garageVisitPlaceList.Items = this.garageVisitPlaceList.Items.filter(p => p.IsActive);

        this.timeSlots = new Array<GarageVisitsModels.GarageVisitsTimeSlotModel>();

        if (this.garageVisitPlaceList.Success && this.garageVisitPlaceList.Items) {

          this.garageVisitPlaceList.Items.forEach(p => {


            p.PlaceTimeSlot.forEach(t => {

              if (!this.timeSlots.some(ts => ts.Id == t.TimeSlot.Id)) {
                this.timeSlots.push(t.TimeSlot);
              }
            }
            )
          });

          this.timeSlots = this.timeSlots.sort((a, b) => (a.Id > b.Id) ? 1 : -1);
        }
      }
    }));

    this.subscription.add(this.GarageVisit$.subscribe((data) => {
      if (data) {
        if (data.Success) {

          if (data.Item.IsDeleteDone) {
            this.garageVisits = this.garageVisits.filter(v => v.GarageVisitId != data.Item.GarageVisitId);
          }
        }
      }
    }));

    this.subscription.add(this.GarageBlockedDayList$.subscribe((result) => {
      if (result && result.Success == true && result.RequestSignature == this.searchDays.RequestSignature) {
        this.blockedDayList = result.Items;
        this.searchDays.End();
      }
    }));


    this.garageVisitsSearch.DateFrom = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1, 0, 0);

    this.garageVisitsSearch.DateTo = new Date(this.garageVisitsSearch.DateFrom.setMonth(this.currentDate.getMonth() + 3));
  }

  public onValidationEmail(error: boolean) {

    this.IsEmailValid = !error;
  }

  public onValidationTelephone(error: boolean) {

    this.IsTelephoneValid = !error;
  }

  onSelect($event: any) {

    this.currentDate.setHours(2);

    this.currentDateId = this.GetDateIdFromDate(this.currentDate);

    this.getGarageVisitsPlace();
  }

  onMonthChange(monthSelected) {

    this.selectedMonth = new Date(monthSelected.year, monthSelected.month - 1, 1);

    this.getGarageVisits(this.selectedMonth);
  }

  public getGarageVisits(GivenDate: Date) {
    this.garageVisitsSearch.DateFrom = new Date(GivenDate.getFullYear(), GivenDate.getMonth(), 1, 0, 0);
    this.garageVisitsSearch.DateTo = new Date(this.garageVisitsSearch.DateTo.setMonth(GivenDate.getMonth() + 3));

    if (this.currentGarage && this.currentGarage.GarageId) {
      this.garageVisitsSearch.GarageId = this.currentGarage.GarageId;
    }

    this.store.dispatch(new GarageVisitsAction.GetGarageVisitList(this.garageVisitsSearch));
  }

  public getCarVisitCount(GivenDate: any): number {



    let result = 0;

    let dateId = this.GetDateId(GivenDate);

    if (this.garageVisits) {

      result = this.garageVisits.filter(gv => gv.DateId == dateId).length;
    }

    return result;
  }

  public GetDateId(GivenDate: any): number {

    var year: number = GivenDate.year * 10000;

    var month: number = (GivenDate.month + 1) * 100;

    var day: number = GivenDate.day;

    return year + month + day;

  }

  public GetDateIdFromDate(GivenDate: Date): number {

    var year: number = GivenDate.getFullYear() * 10000;

    var month: number = (GivenDate.getMonth() + 1) * 100;

    var day: number = GivenDate.getDate();

    return year + month + day;

  }

  public getGarageVisitsPlace() {

    this.garageVisitsPlaceSearch.Date = this.currentDate;
    this.garageVisitsPlaceSearch.DateId = this.GetDateIdFromDate(this.currentDate);

    if (this.currentGarage && this.currentGarage.GarageId) {
      this.garageVisitsPlaceSearch.GarageId = this.currentGarage.GarageId;
    }

    this.store.dispatch(new GarageVisitsAction.GetGarageVisitPlaceList(this.garageVisitsPlaceSearch));
  }

  public getGarageBlockedDays() {

    this.searchDays.IsPagination = false;

    if (this.currentGarage && this.currentGarage.GarageId) {
      this.searchDays.GarageId = this.currentGarage.GarageId;
    }

    this.store.dispatch(new GarageVisitsAction.GetGarageBlockedDaysList(this.searchDays));
  }

  public SetTimeSlotStyles(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): object {

    let retur: object = null;

    if (!GarageVisitPlace.PlaceTimeSlot.some(ts => ts.TimeSlot.Id == TimeSlot.Id)) {
      retur = { 'opacity': '0' };
    }
    else if (!this.IsTimeSlotFree(TimeSlot, GarageVisitPlace)) {

      let garageVisit: GarageVisitsModels.GarageVisitModel = this.GetGarageVisit(TimeSlot, GarageVisitPlace);

      retur = { 'background': '#0091D5', 'color': '#000' };

    }
    else if (this.helperService.GetDateId(this.currentDate) < this.helperService.GetDateId(this.now) || TimeSlot.IsBlocked) {
      retur = { 'opacity': '0.4' };
    }

    return retur;
  }

  public IsCarPlace(GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): boolean {

    return GarageVisitPlace.IsEnableCar && !GarageVisitPlace.IsEnableTruck;
  }

  public IsTrackPlace(GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): boolean {

    return GarageVisitPlace.IsEnableTruck;
  }

  public IsGarageOpen(): boolean {
    return this.garageVisitPlaceList.Items.reduce((pn, u) => [...pn, ...u.PlaceTimeSlot], []).length > 0;
  }

  public GarageVisitPlaceOnlineCount(): number {
    return this.garageVisitPlaceList.Items.filter(p => p.IsEnableOnline === true).length;
  }

  public GarageVisitPlaceOfflineCount(): number {
    return this.garageVisitPlaceList.Items.filter(p => p.IsEnableOnline === false).length;
  }

  public GarageVisitPlaceOnline(): GarageVisitsModels.GarageVisitsPlaceModel[] {
    return this.garageVisitPlaceList.Items.filter(p => p.IsEnableOnline === true).sort((a, b) => (a.Name > b.Name) ? 1 : -1);
  }

  public GarageVisitPlaceOffline(): GarageVisitsModels.GarageVisitsPlaceModel[] {
    return this.garageVisitPlaceList.Items.filter(p => p.IsEnableOnline === false).sort((a, b) => (a.Name > b.Name) ? 1 : -1);
  }

  public IsTimeSlotFree(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): boolean {

    return !this.garageVisits.some(gv => gv.TimeSlotId == TimeSlot.Id && gv.GaragePlaceId == GarageVisitPlace.GaragePlaceId && gv.DateId == this.helperService.GetDateId(this.currentDate));

  }

  public IsTimeSlotDisplay(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): boolean {

    let isFree = this.IsTimeSlotFree(TimeSlot, GarageVisitPlace);

    if (isFree) {
      return true;
    }
    else {
      let garageVisit: GarageVisitsModels.GarageVisitModel = this.GetGarageVisit(TimeSlot, GarageVisitPlace);

      if (garageVisit && garageVisit.BaseGarageVisitId) {
        return false;
      }
      else {
        return true;
      }
    }
  }

  public GetGarageVisit(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): GarageVisitsModels.GarageVisitModel {

    if (!this.IsTimeSlotFree(TimeSlot, GarageVisitPlace)) {
      return this.garageVisits.filter(gv => gv.TimeSlotId == TimeSlot.Id && gv.GaragePlaceId == GarageVisitPlace.GaragePlaceId && gv.DateId == this.helperService.GetDateId(this.currentDate))[0];
    }
  }

  public AddNewVisit(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel) {

    if (!GarageVisitPlace.PlaceTimeSlot.some(ts => ts.TimeSlot.Id == TimeSlot.Id)) {
      return;
    }

    if (this.helperService.GetDateId(this.currentDate) >= this.helperService.GetDateId(this.now) && this.IsTimeSlotFree(TimeSlot, GarageVisitPlace) && !TimeSlot.IsBlocked) {

      this.visitTimeSlot = TimeSlot;

      this.visitGarageVisitPlace = GarageVisitPlace;

      if (this.visitGarageVisitPlace && this.visitTimeSlot && this.currentDate) {

        this.newGarageVisit = new GarageVisitsModels.GarageVisitModel();
        this.newGarageVisit.GaragePlaceId = this.visitGarageVisitPlace.GaragePlaceId;
        this.newGarageVisit.GaragePlaceName = this.visitGarageVisitPlace.Name;
        this.newGarageVisit.GaragePlaceIsEnableCar = this.visitGarageVisitPlace.IsEnableCar;
        this.newGarageVisit.GaragePlaceIsEnableTruck = this.visitGarageVisitPlace.IsEnableTruck;

        this.newGarageVisit.Date = new Date(Date.UTC(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate(), this.visitTimeSlot.Hour, this.visitTimeSlot.Minutes));
        this.newGarageVisit.VisitDate = this.newGarageVisit.Date.getFullYear() + "-" + (this.currentDate.getMonth() + 1) + "-" + this.currentDate.getDate();
        this.newGarageVisit.TimeSlotId = this.visitTimeSlot.Id;
        this.newGarageVisit.TimeSlotLabel = this.visitTimeSlot.Label;

        this.currentStep = 1;
      }
    }  
  }

  public SetRowSpan(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): number {

    if (this.garageVisits) {
      return this.garageVisits.some(gv => gv.TimeSlotId == TimeSlot.Id && gv.GaragePlaceId == GarageVisitPlace.GaragePlaceId && gv.DateId == this.helperService.GetDateId(this.currentDate) && gv.IsTruck === true) ? 2 : 1;
    }
    else {
      return null;
    }
  }

  public IsReservationValid(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): boolean {

    if (TimeSlot.IsBlocked || this.helperService.GetDateId(this.currentDate) < this.helperService.GetDateId(this.now)) {
      return false;
    }
    else {
      return this.IsTimeSlotFree(TimeSlot, GarageVisitPlace);
    }
  }

  public IsDayBlocked(GivenDate: any): boolean {

    let isBlocked: boolean = false;

    let dateId = this.GetDateId(GivenDate);

    isBlocked = this.blockedDayList.some(bd => bd.DateId == dateId);

    if (!isBlocked) {
      let givenDate: Date = new Date(Date.UTC(GivenDate.year, GivenDate.month, GivenDate.day, 1, 0));

      let dayOfWeek = givenDate.getDay();

      if (dayOfWeek == 0) {

        isBlocked = !this.garageVisitPlaceList.Items.some(p => p.SundayOpenHour);
      }

      if (dayOfWeek == 6) {

        isBlocked = !this.garageVisitPlaceList.Items.some(p => p.SaturdayOpenHour);
      }
    }

    return isBlocked;
  }

  public onBack(): void {
    this.currentStep = 0;
  }
}
